(function() {
	'use strict';

	angular
	.module('website', [
    'ngSanitize',
    'spApi',
    'spNotify',
    'angularSmoothscroll',
    'angular.vertilize'
		]);
})();

(function() {
	'use strict';

	angular
	.module('website')
	.controller('TestimonialsController', TestimonialsController);

	/** @ngInject */
	function TestimonialsController(spTestimonialService, $timeout) {
		var vm = this;

    vm.inLoading = true;

    spTestimonialService.loadTestimonials({
      filters:{
        highlighted: true
      }
    }).then(function (result) {
      vm.testimonials = result.data;

      vm.inLoading = false;

      $timeout(function (){
        angular.element('#testimonials-owl').owlCarousel({
          singleItem:true,
          autoHeight: false,
          navigation: false,
          pagination: true
        });
      });
    });
	}
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ServicesController', ServicesController);

  /** @ngInject */
  function ServicesController(spGalleriesService, $timeout, $window) {
    var vm = this;

    vm.inLoading = true;
    vm.opened = [];

    vm.open = function(id) {
      vm.opened[id] = true;
    };
    vm.close = function(id) {
      vm.opened[id] = false;
    };
    vm.isOpened = function(id) {
      return vm.opened[id] || false;
    };

    spGalleriesService.loadGallery(2).then(function(result) {
      vm.meta = result.meta;
      vm.gallery = result.data;

      spGalleriesService.loadPhotos(2).then(function(result) {
        vm.meta = result.meta;
        vm.photos = result.data;

        vm.inLoading = false;

        $timeout(function() {
          angular.element($window).trigger('resize');
        });
      });
    })
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('PhotosController', PhotosController);

  /** @ngInject */
  function PhotosController(spGalleriesService) {
    var vm = this;

    vm.inLoading = false;
    vm.isEnd = false;
    vm.photos = [];

    vm.load = function() {
      if (vm.inLoading || vm.isEnd) {
        return;
      }
      vm.inLoading = true;

      spGalleriesService.loadPhotos(1, {
        offset:vm.photos.length,
        limit:8
      }).then(function(result){
        vm.meta = result.meta;
        if (result.data.length) {
          angular.forEach(result.data, function(photo){
            vm.photos.push(photo);
          })
        } else {
          vm.isEnd = true;
        }

        vm.inLoading = false;
      });
    };

    vm.load();
  }
})();

(function() {
	'use strict';

	angular
	.module('website')
	.controller('PartnersController', PartnersController);

	/** @ngInject */
	function PartnersController(spGalleriesService, $timeout) {
		var vm = this;

    vm.inLoading = true;

    spGalleriesService.loadPhotos(3, {
      limit: 20
    }).then(function(result) {
      vm.meta = result.meta;
      vm.photos = result.data;

      vm.inLoading = false;

      $timeout(function () {
        angular.element('#partners-owl').owlCarousel({
          loop: true,
          items: 5,
          navigation: false,
          pagination: false,
          autoPlay: true,
          responsive: {
            0: {
              items:1
            },
            768: {
              items:3
            }
          }
        });
      });
    });
	}
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('FooterController', FooterController);

  /** @ngInject */
  function FooterController(spPagesService) {
    var vm = this;

    vm.inLoading = true;
    vm.modalOpened = false;

    vm.modalOpen = function() {
      vm.modalOpened = true;
    };
    vm.modalClose = function() {
      vm.modalOpened = false;
    };

    spPagesService.loadPage(2).then(function(result) {
      vm.page = result.data;

      vm.inLoading = false;
    })
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController(spContactService, spPagesService) {
    var vm = this;

    vm.inLoading = true;

    vm.formData = {
      extras: {
        'type' : {
          'title': 'Votre prestation'
        },
        'date' : {
          'title': 'Date de l\'événement'
        },
        'count' : {
          'title': 'Nombre d\'invités'
        },
        'place' : {
          'title': 'Lieu de l\'événement'
        },
        'known' : {
          'title': 'Comment m\'avez vous connu'
        }
      }
    };
    vm.inSubmit = false;

    vm.send = function () {
      if (vm.inSubmit) {
        return;
      }

      vm.inSubmit = true;
      vm.formNotify = {}

      spContactService.send(vm.formData).then(function (result) {
        vm.formNotify = {success: result};
        vm.formData = {};
        vm.inSubmit = false;
      }, function (result) {
        vm.formNotify = {error: result.messages};
        vm.inSubmit = false;
      });
    };

    spPagesService.loadPage(3).then(function (result) {
      vm.page = result.data;

      vm.inLoading = false;
    })
  }
})();

(function() {
  'use strict';

  angular
    .module('website')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController(spMetaService, spPagesService) {
    var vm = this;

    vm.inLoading = true;

    spPagesService.loadPage(1).then(function(result) {
      vm.page = result.data;

      spMetaService.set({
        title: vm.page.metaTitle,
        description: vm.page.metaDescription
      });

      vm.inLoading = false;
    })
  }
})();

(function () {
  'use strict';

  angular
    .module('spNotify', [])
    .directive('notify', NotifyDirective);

  /** @ngInject */
  function NotifyDirective() {
    return {
      restrict: 'A',
      scope: {
        notify: "="
      },
      template: '<div class="notify {{type}}" ng-show="messages"><ul>' +
      '<li ng-repeat="message in messages">{{message}}</li>' +
      '</ul></div>',
      controller: function ($scope) {
        $scope.$watch('notify', function (v) {
          if (!v) {
            return;
          }

          if (v.hasOwnProperty('error')) {
            $scope.messages = v.error;
            $scope.type = 'error';
          } else if (v.hasOwnProperty('success')) {
            $scope.messages = v.success;
            $scope.type = 'success';
          } else {
            $scope.messages = null;
            $scope.type = null;
          }
        }, true);
      }
    };
  }
})();

(function () {
  'use strict';
  angular.module('website')
    .directive('menu', MenuDirective);

  /** @ngInject */
  function MenuDirective($compile, $document, $window) {
    var getCurrentScroll = function() {
        return $window.pageYOffset || $document[0].documentElement.scrollTop;
    };

    return {
        restrict: 'A',
        link: function (scope, element) {
          scope.init = function()
          {
            angular.element('.slicknav_menu').remove();

            var $nav = angular.element('<ul></ul>');

            $nav.append(angular.element('li', element).clone());

            $nav.slicknav({
              label: '',
              prependTo: '#nM',
              closeOnClick: true,
              init: function () {
                var $menu = angular.element('.slicknav_menu');
                $menu.prepend(
                  '<a smooth-scroll target="top">' +
                    '<img id="slicklogo" src="../assets/images/logo-small.png">' +
                  '</a>'
                );

                $compile($menu.contents())(scope);
              }
            });
          };

          var offsetTop = element.offset().top;
          angular.element($window).on('scroll', function () {
              if (getCurrentScroll() >= offsetTop && $window.innerWidth >= 1240) {
                  element.addClass('top');
              } else {
                  element.removeClass('top');
              }
          });

          scope.init();
        }
    };
  }
})();

/* global imagesLoaded:false, Masonry:false */
(function () {
  'use strict';

  angular
    .module('website')
    .directive('masonry', function ($timeout) {
      return {
        restrict: 'A',
        link: function ($scope, $element, attrs) {
          var timer;

          $scope.masonry = new Masonry($element[0], angular.extend({
            itemSelector: '*[masonry-item]'
          }, $scope.$eval(attrs.masonry)));

          $scope.update = function () {
            $scope.masonry.reloadItems();
            $scope.masonry.layout();
          };

          $scope.append = function (item) {
            $scope.masonry.appended(item);
          };

          $scope.schedule = function schedule(action) {
            if (timer) {
              $timeout.cancel(timer);
            }

            timer = $timeout(function () {
              $scope[action]();
            }, 100);
          };
        }
      };
    });

  angular
    .module('website')
    .directive('masonryItem', function ($timeout) {
      return {
        restrict: 'AC',
        link: function (scope, element) {
          $timeout(function() {
            var masonryScope = element.parent('*[masonry]:first').scope();
            masonryScope.append(element);

            imagesLoaded(element, function () {
              masonryScope.schedule('update');
            });
          });
        }
      };
    });

})();

(function () {
  'use strict';

  angular
    .module('website')
    .directive('loader', SpinnerDirective);

  /** @ngInject */
  function SpinnerDirective() {
    return {
      restrict: 'ACE',
      replace: true,
      template: '<div class="spinner">\
        <div class="spinner1"></div>\
        <div class="spinner2"></div>\
        <div class="spinner3"></div>\
        <div class="spinner4"></div>\
      </div>'
    };
  }
})();

(function () {
  'use strict';

  angular.module('website')
    .directive('html', function() {
      return {
        link: function (scope, element) {
          if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
            angular.element(element).addClass('tch');
          } else {
            angular.element(element).addClass('_tch');
          }
        }
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('website')
    .run(runBlock);

  /** @ngInject */
  function runBlock(spMetaService, spParametersService, $location, $rootScope, $window) {
    $window.ga('create', 'UA-75641067-1', 'auto');

    $rootScope.spMetaService = spMetaService;
    $rootScope.spParametersService = spParametersService;

    spMetaService.setDefaults({
      titleSuffix: 'Décoration mariages et cérémonie laïque Poitiers  - Lilie Créatrice de vos Evénements',
      siteName: 'Lilie Créatrice de vos Evénements',
      card: 'Lilie Créatrice de vos Evénements'
    });

    spParametersService.loadParameters([
      'SOCIAL_FACEBOOK',
      'SOCIAL_PINTEREST',
      'SOCIAL_GOOGLE_PLUS',
      'SOCIAL_BLOG',
      'CONTACT_EMAIL',
      'CONTACT_TELEPHONE',
      'CONTACT_TEXT'
    ]);

    var stateChangeSuccess = $rootScope.$on("$stateChangeSuccess", function () {
      $window.ga('send', 'pageview', $location.path());
    });

    $rootScope.$on("$destroy", function() {
      stateChangeSuccess();
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('website')
    .config(config);

  /** @ngInject */
  function config($locationProvider) {
    $locationProvider.hashPrefix('!');
  }

})();

angular.module("website").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/menu/menu.html","<div id=\"nM\"></div><section id=\"h\" class=\"clearfix\"><div id=\"n\" menu=\"\"><div class=\"rw\"><ul id=\"menu\"><li><a smooth-scroll=\"\" target=\"about\" title=\"À propos\">À propos</a></li><li><a smooth-scroll=\"\" target=\"services\" title=\"Services\">Services</a></li><li><a smooth-scroll=\"\" target=\"photos\" title=\"Photos\">Photos</a></li><li class=\"logo\"><a smooth-scroll=\"\" target=\"top\"><img src=\"assets/images/logo.png\" alt=\"Logo\" title=\"Logo\"></a></li><li><a ng-href=\"{{spParametersService.get(\'SOCIAL_BLOG\')}}\" target=\"_blank\" title=\"Blog\">Blog</a></li><li><a smooth-scroll=\"\" offset=\"150\" target=\"partners\" title=\"Partenaires\">Partenaires</a></li><li><a smooth-scroll=\"\" target=\"contact\" title=\"Contact\">Contact</a></li></ul></div></div></section>");
$templateCache.put("app/sections/about/about.html","<section id=\"about\" ng-controller=\"AboutController as abtCtrl\"><div ng-if=\"!abtCtrl.inLoading\" class=\"rw\"><h1 ng-bind-html=\"abtCtrl.page.title | html\"></h1><div ng-bind-html=\"abtCtrl.page.description | html\"></div></div><loader ng-show=\"abtCtrl.inLoading\"></loader></section>");
$templateCache.put("app/sections/contact/contact.html","<section id=\"contact\" ng-controller=\"ContactController as cntctCtrl\"><h1>{{cntctCtrl.page.title}}</h1><div ng-if=\"!cntctCtrl.inLoading\" class=\"rw clearfix\"><div id=\"contact-left\"><div class=\"slogan\"><div class=\"lilie\"><div><img src=\"assets/images/lilie.jpg\" alt=\"Lilie\" title=\"Lilie\"></div></div><span ng-bind-html=\"spParametersService.get(\'CONTACT_TEXT\') | html\"></span></div><div class=\"com\"><ul><li id=\"tel\"><i class=\"fa fa-phone\"></i> {{spParametersService.get(\'CONTACT_TELEPHONE\')}}</li><li id=\"mail\"><i class=\"fa fa-at\"></i> <a href=\"mailto:{{spParametersService.get(\'CONTACT_EMAIL\')}}\">{{spParametersService.get(\'CONTACT_EMAIL\')}}</a></li><li><a class=\"facebook\" ng-href=\"{{spParametersService.get(\'SOCIAL_FACEBOOK\')}}\" target=\"_blank\"><i class=\"fa fa-facebook\"></i></a></li><li><a class=\"pinterest\" ng-href=\"{{spParametersService.get(\'SOCIAL_PINTEREST\')}}\" target=\"_blank\"><i class=\"fa fa-pinterest-p\"></i></a></li><li><a class=\"google-plus\" ng-href=\"{{spParametersService.get(\'SOCIAL_GOOGLE_PLUS\')}}\" target=\"_blank\"><i class=\"fa fa-google-plus\"></i></a></li><li><a class=\"rss\" ng-href=\"{{spParametersService.get(\'SOCIAL_BLOG\')}}\" target=\"_blank\"><i class=\"fa fa-rss\"></i></a></li></ul></div></div><div id=\"contact-right\"><form ng-submit=\"cntctCtrl.send()\" class=\"clearfix\"><div class=\"clearfix\"><div class=\"form-field\"><input type=\"text\" name=\"lastname\" ng-model=\"cntctCtrl.formData.lastname\" placeholder=\"Nom*\"></div><div class=\"form-field\"><input type=\"text\" name=\"firstname\" ng-model=\"cntctCtrl.formData.firstname\" placeholder=\"Prénom*\"></div><div class=\"form-field\"><input type=\"email\" name=\"email\" ng-model=\"cntctCtrl.formData.email\" placeholder=\"Email*\"></div><div class=\"form-field\"><input type=\"text\" name=\"telephone\" ng-model=\"cntctCtrl.formData.telephone\" placeholder=\"Téléphone*\"></div><div class=\"form-field\"><div class=\"select\"><select ng-model=\"cntctCtrl.formData.extras.type.value\" placeholder=\"\"><option value=\"\">Votre prestation</option><option value=\"Cérémonie Laïque\">Cérémonie Laïque</option><option value=\"Décoration événementiel\">Décoration événementiel</option><option value=\"Les deux\">Les deux</option></select></div></div><div class=\"form-field\"><input type=\"text\" ng-model=\"cntctCtrl.formData.extras.date.value\" placeholder=\"Date de votre évènement\"></div><div class=\"form-field\"><input type=\"text\" ng-model=\"cntctCtrl.formData.extras.count.value\" placeholder=\"Nombre d\'invités\"></div><div class=\"form-field\"><input type=\"text\" ng-model=\"cntctCtrl.formData.extras.place.value\" placeholder=\"Lieu de l\'évènement\"></div><div class=\"form-field form-field-full\"><input type=\"text\" ng-model=\"cntctCtrl.formData.extras.known.value\" placeholder=\"Comment avez-vous connu Lilie ?\"></div><div class=\"form-field form-field-full\"><textarea ng-model=\"cntctCtrl.formData.message\" placeholder=\"Message*\"></textarea></div></div><div notify=\"cntctCtrl.formNotify\"></div><loader ng-if=\"cntctCtrl.inSubmit\"></loader><button type=\"submit\">Envoyer</button></form></div></div><loader ng-show=\"cntctCtrl.inLoading\"></loader></section>");
$templateCache.put("app/sections/footer/footer.html","<div id=\"f\" ng-controller=\"FooterController as ftrCtrl\"><footer class=\"rw\"><a id=\"fs\" href=\"http://www.supa-creation.com\" title=\"Sites Internet - Applications Smartphones - Impression - Poitiers - SuPa-Creation.com\">Sites Internet - Applications Smartphones - Impression - Poitiers</a><p>Copyright 2016. Tous droits réservés. Poitiers (Vienne 86) Niort (Deux-Sèvres 79) Angoulême (Charente 16) - <a ng-click=\"ftrCtrl.modalOpen()\">Mentions Légales</a></p></footer><div class=\"modal\" ng-show=\"ftrCtrl.modalOpened\"><div class=\"modal-content\"><a class=\"close\" ng-click=\"ftrCtrl.modalClose()\">x</a><h1 ng-bind-html=\"ftrCtrl.page.title | html\"></h1><div ng-bind-html=\"ftrCtrl.page.description | html\"></div></div></div></div>");
$templateCache.put("app/sections/partners/partners.html","<section id=\"partners\" ng-controller=\"PartnersController as prtnrsCtrl\"><div ng-show=\"!prtnrsCtrl.inLoading\" class=\"rw\"><div id=\"partners-owl\"><a ng-href=\"{{photo.url}}\" target=\"_blank\" ng-repeat=\"photo in prtnrsCtrl.photos\"><img ng-src=\"{{prtnrsCtrl.meta.basePath}}/u/g/4/{{photo.slug}}.{{photo.sizes[4].extension}}\" alt=\"{{photo.title}}\" title=\"{{photo.title}}\"></a></div></div><loader ng-show=\"prtnrsCtrl.inLoading\"></loader></section>");
$templateCache.put("app/sections/photos/photos.html","<section id=\"photos\" ng-controller=\"PhotosController as phtsCtrl\"><div class=\"rw\"><h1>Photos</h1><div masonry=\"{columnWidth:\'#photos-width\', gutter:\'#photos-gutter\'}\"><figure masonry-item=\"\" ng-repeat=\"photo in phtsCtrl.photos\"><img ng-src=\"{{phtsCtrl.meta.basePath}}/u/g/1/{{photo.slug}}.{{photo.sizes[1].extension}}\" alt=\"{{photo.title}}\" title=\"{{photo.title}}\"></figure><div id=\"photos-width\"></div><div id=\"photos-gutter\"></div></div></div><loader ng-show=\"phtsCtrl.inLoading\"></loader><div id=\"photos-more\" ng-show=\"!phtsCtrl.isEnd\"><span ng-click=\"phtsCtrl.load()\" class=\"button button-circle button-small\"><i class=\"fa fa-plus\"></i></span></div></section>");
$templateCache.put("app/sections/services/services.html","<section id=\"services\" ng-controller=\"ServicesController as srvcsCtrl\"><div ng-show=\"!srvcsCtrl.inLoading\" class=\"rw clearfix\"><h1>{{srvcsCtrl.gallery.title}}</h1><div class=\"ribbon\" ng-if=\"srvcsCtrl.gallery.subTitle\"><div class=\"ribbon-stitches-top\"></div><strong class=\"ribbon-content\"><h2><a smooth-scroll=\"\" target=\"contact\">{{srvcsCtrl.gallery.subTitle}}</a></h2></strong><div class=\"ribbon-stitches-bottom\"></div></div><div class=\"cn\"><div vertilize-container=\"\"><div class=\"flip-container\" ng-repeat=\"photo in srvcsCtrl.photos\" ng-class=\"{\'hover\': srvcsCtrl.isOpened(photo.id)}\"><div vertilize=\"\" class=\"flipper\"><div vertilize=\"\" class=\"front\"><div><img ng-src=\"{{srvcsCtrl.meta.basePath}}/u/g/3/{{photo.slug}}.{{photo.sizes[3].extension}}\" alt=\"Organisation\"><div ng-bind-html=\"photo.shortDescription | html\"></div><div class=\"see\"><span class=\"button button-circle button-small more\" ng-click=\"srvcsCtrl.open(photo.id)\"><i class=\"fa fa-plus\"></i></span></div></div></div><div vertilize=\"\" class=\"back\"><div><div class=\"back-title\">{{photo.title}}</div><div ng-bind-html=\"photo.description | html\"></div><div class=\"see\"><a class=\"button button-circle button-small less\" ng-click=\"srvcsCtrl.close(photo.id)\"><i class=\"fa fa-minus\"></i></a></div></div></div></div></div></div></div></div><loader ng-show=\"srvcsCtrl.inLoading\"></loader></section>");
$templateCache.put("app/sections/testimonials/testimonials.html","<section id=\"testimonials\" ng-controller=\"TestimonialsController as tstmnlsCtrl\"><h1 class=\"white\">Témoignages</h1><div ng-if=\"!tstmnlsCtrl.inLoading\" class=\"rw\"><div id=\"testimonials-owl\"><div class=\"item\" ng-repeat=\"testimonial in tstmnlsCtrl.testimonials\"><p>{{testimonial.text}}</p><span>{{testimonial.name}}</span></div></div></div><loader ng-if=\"tstmnlsCtrl.inLoading\"></loader></section>");}]);